import jQuery from "jquery";

(function ($) {
    if ($("form").length) {
        const debounce = (func, delay) => {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        };

        const handleFieldChange = function () {
            const $field = $(this);
            const $parentCell = $field.closest(".cell");

            $field.removeClass("is-invalid-input");
            $parentCell.find("label").removeClass("is-invalid-label");
            $parentCell.find(".form-error").removeClass("is-visible");
            $field.removeAttr("aria-invalid aria-describedby");

            const $compositeWrapper = $field.closest(".grid-x.grid-margin-x");
            if ($compositeWrapper.length) {
                const $compositeParent = $compositeWrapper.closest(".cell");
                $compositeParent.find("input").removeClass("is-invalid-input");
                $compositeParent.find("label").removeClass("is-invalid-label");
                $compositeParent.find(".form-error").removeClass("is-visible");
            }

            if (
                $field.attr("type") === "radio" ||
                $field.attr("type") === "checkbox"
            ) {
                const groupName = $field.attr("name");
                const $group = $(`input[name="${groupName}"]`);
                const $groupCell = $group.closest(".cell");
                $group.removeClass("is-invalid-input");
                $groupCell.find("label").removeClass("is-invalid-label");
                $groupCell.find(".form-error").removeClass("is-visible");
            }

            if (!$field.hasClass("dz-hidden-input")) {
                const $abideForm = $field.closest("form[data-abide]");
                if ($abideForm.length) {
                    $abideForm.foundation("validateInput", $field);
                }
            }

            if ($field.is("[data-equalto]")) {
                const targetSelector = $field.attr("data-equalto");
                const $targetField = $(targetSelector);
                const $abideForm = $targetField.closest("form[data-abide]");
                if ($abideForm.length) {
                    $abideForm.foundation("validateInput", $targetField);
                }
            }
        };

        $(document).on(
            "input change",
            "input, textarea, select",
            debounce(handleFieldChange, 150)
        );
    }
})(jQuery);

window.addEventListener('load', function () {
    if (window.location.search.includes('form_id=')) {
        setTimeout(function () {
            history.replaceState(null, '', window.location.pathname);
        }, 100);
    }
});
